import { ScanDataSubmissionType } from '@occc/graphql';

import { TabValue } from './scan-data.types';

const SCAN_DATA_BASE_URL = '/scan-data';

export const routeCreator = {
  base: () => SCAN_DATA_BASE_URL,
  scanDataWithTab: (tab: TabValue) => `${SCAN_DATA_BASE_URL}/${tab}`,
  overview: () => routeCreator.scanDataWithTab('overview'),
  weeklyFile: () => routeCreator.scanDataWithTab('weekly-file'),
  submissionGroups: () => routeCreator.scanDataWithTab('submission-groups'),
  submissionGroupsCreate: () => `${SCAN_DATA_BASE_URL}/submission-groups-create`,
  submissionGroupsUpdate: (id: ':id' | string) =>
    `${SCAN_DATA_BASE_URL}/submission-groups-update/${id}`,
  submissionGroupsDetails: (id: ':id' | string) =>
    `${SCAN_DATA_BASE_URL}/submission-groups-details/${id}`,
  pastSubmissionView: (params: {
    date: ':date' | string;
    type: ':type' | ScanDataSubmissionType;
  }) => `${SCAN_DATA_BASE_URL}/past-submission/${params.date}/${params.type}`,
};
